export enum IdpEntityIds {
  AAPT = 'AAPTIMISIDP',
}
